import React, { useRef, useState, useEffect } from "react";
import styles from "../styles/Developers.module.css"; // Create a CSS module for this page
import developerImage from "../assets/dev.jpg";
import check from "../assets/developer2.png";
import api from "../assets/developer1.png";
import API from "../assets/merchant.svg";
import pay from "../assets/Frame 1171275121.svg";
import wall from "../assets/wallet.svg";
import pic from "../assets/api.svg";
import cool from "../assets/new.svg";
import secur from "../assets/secu.svg";
import tool from "../assets/developer3.png";
import winner from "../assets/win.png";
import video from "../assets/vid.mp4";
import hack from "../assets/8.jpg";
import final from "../assets/2.jpg";
import { useLocation } from "react-router-dom";

import Footer from "../components/Footer";
import Header from "../components/Header";

function Developers() {
  const location = useLocation();
  useEffect(() => {
  window.scrollTo(0, 0);
}, []); // ← empty dependency array = run only on mount


  // useEffect(()=>[
  //   window.scrollTo(0,0)
  // ][location])

  const [ApiCurrentPage, setApiCurrentPage] = useState(1);
  const [ApiItemsPerPage, setApiItemsPerPage] = useState(0);
  const [deployCurrentPage, setDeployCurrentPage] = useState(1);
  const [deployItemsPerPage, setDeployItemsPerPage] = useState(0);
  const [eventsCurrentPage, setEventsCurrentPage] = useState(1);
  const [eventsItemsPerPage, setEventsItemsPerPage] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const ApiPageRef = useRef(null);
  const deployRef = useRef(null);
  const eventsRef = useRef(null);

  useEffect(() => {
    const updateItemsPerPage = () => {
      setIsSmallScreen(window.innerWidth < 960);
      if (window.innerWidth < 600) {
        setApiItemsPerPage(1);
        setDeployItemsPerPage(1);
        setEventsItemsPerPage(1);
      } else if (window.innerWidth < 960) {
        setApiItemsPerPage(2);
        setDeployItemsPerPage(2);
        setEventsItemsPerPage(2);
      } else {
        setApiItemsPerPage(3);
        setDeployItemsPerPage(3);
        setEventsItemsPerPage(3);
      }
    };

    updateItemsPerPage();
    window.addEventListener("resize", updateItemsPerPage);

    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

  const handleApiPageChange = (pageNumber) => {
    setApiCurrentPage(pageNumber);
      e.preventDefault();
  };
  const handleDeployPageChange = (pageNumber) => {
    setDeployCurrentPage(pageNumber);
    e.preventDefault();
    
  };

const handleEventsPageChange = (pageNumber) => {
  // Save current scroll position before state update
  const scrollPosition = window.scrollY || document.documentElement.scrollTop;
  
  // Update the page state
  setEventsCurrentPage(pageNumber);
  
  // Restore scroll position after the state update completes
  setTimeout(() => {
    window.scrollTo(0, scrollPosition);
  }, 0);
};

  const handleTelegramLogin = () => {
    window.open("http://t.me/arifochet");
  };

  const test = [
    {
      img: pay,
      text: (
        <span>
          <h2>Payment API</h2>
          <p style={{ fontSize: "1.3em" }}>
            Accept online and mobile payments
            <br />
            effortlessly
          </p>
        </span>
      ),
    },
    {
      img: API,
      text: (
        <span>
          <h2>Merchant API</h2>
          <p style={{ fontSize: "1.3em" }}>
            Manage transactions, refunds, and
            <br />
            settlements
          </p>
        </span>
      ),
    },
    {
      img: wall,
      text: (
        <span>
          <h2>Wallet API</h2>
          <p style={{ fontSize: "1.3em" }}>
            Enable digital wallet services for customers
          </p>
        </span>
      ),
    },
  ];

  const deployData = [
    {
      img: pic,
      text: (
        <span style={{ fontSize: "1.3em" }}>
          Use our Sandbox Environment to test transactions before going{" "}
          <span style={{ color: "var(--primary-green)" }}>live</span>
        </span>
      ),
    },
    {
      img: cool,
      text: (
        <span style={{ fontSize: "1.3em" }}>
          Get real-time analytics and insights through our dashboard.
        </span>
      ),
    },
    {
      img: secur,
      text: (
        <span style={{ fontSize: "1.3em" }}>
          Get real-time analytics and insights through our dashboard.
        </span>
      ),
    },
  ];

  const eventsData = [
    {
      date: "20 Jan 2023",
      title: "Winner of Arifdevelopers event",
      type: "image",
      src: winner,
      // image: winner,
    },

    {
      date: "20 Jan 2023",
      title: "Hackathon",
      type: "image",
      src: hack,
    },
    {
      date: "20 Jan 2023",
      title: "Hackathon Final",
      type: "image",
      src: final,
    },
    {
      date: "20 Jan 2024",
      title: "Arifpay 1.0 launch day",
      type: "video",
      src: video,
    },
  ];

  const displayedTestData = test.slice(
    (ApiCurrentPage - 1) * ApiItemsPerPage,
    ApiCurrentPage * ApiItemsPerPage
  );

  const displayedDeployData = deployData.slice(
    (deployCurrentPage - 1) * deployItemsPerPage,
    deployCurrentPage * deployItemsPerPage
  );

  const displayedEventsData = eventsData.slice(
    (eventsCurrentPage - 1) * eventsItemsPerPage,
    eventsCurrentPage * eventsItemsPerPage
  );

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <header
          style={{
            backgroundColor: "black",
            color: "white",
            padding: "10px 20px",
            alignItems: "center",
            justifyContent:"center",
          }}
        >
          Get the{" "}
          <a
            href="/assets/Arifpay.postman_collection_new.json"
            download
            className={styles.greenText}
            style={{
              textDecoration: "underline",
              color: "#00ff00",
              cursor: "pointer",
            }}
          >
            API Collection
          </a>{" "}
          for Arif Gateway
        </header>

        <section
          className={styles.hero}
          style={{ margin: 0, paddingLeft: "20px", paddingRight: "20px" }}
        >
          <h1 style={{ fontSize: "3.5em" }} className={styles.heroTitle}>
            Arifpay for Developers
          </h1>
          <p style={{ fontSize: "2.4em", color: "black" }}>
            Best API integration in Ethiopia for digital payments
          </p>
          <p style={{ fontSize: "1.4em" }} className={styles.heroDescription}>
            Welcome to the Arifpay Developer Hub - your gateway to seamless,
            secure, and
            <span className={styles.mobileBreak}>
              <br />{" "}
            </span>
            scalable FinTech integrations in Ethiopia. Whether you're building a payment
            solution,
            <br />
            embedding financial services, or automating transactions, our APIs
            and developer
            <span className={styles.mobileBreak}>
              <br />{" "}
            </span>
            resources are designed to help you innovate with ease.
          </p>
          <div className={styles.heroButtons}>
            {/* <button className={styles.primaryButton}>
              Jump to Integration <span className={styles.arrow}>→</span>
            </button> */}
            <a href="https://developer.arifpay.net">
              <button
                style={{
                  height: "50px",
                  paddingTop: "15px",
                  borderRadius: "10px",
                }}
                className={styles.documentationButton}
              >
                Read Documentation
              </button>
            </a>
          </div>
        </section>

        <section
          className={styles.illustrationSection}
          style={{
            position: "relative",
            textAlign: "center",
            marginTop: "0",
          }}
        >
          <img
            src={developerImage}
            alt="Developer Devices"
            className={styles.developerImage}
          />
        </section>

        <section className={styles.dev}>
          <div className={styles.viewText} style={{ flex: 1 }}>
            <p className={styles.sectionLabel}>PAYMENT SOLUTIONS</p>
            <h3 style={{ fontSize: "2.2em" }}>Get Started with Arifpay</h3>
            <p
              style={{ fontSize: "20px", color: "black" }}
              className={styles.paragraph}
            >
              Start integrating Arifpay's powerful payment solutions in just a
              few steps:
            </p>
            <p className={styles.iconParagraph}>
              <span className={styles.icon}>✦</span> Sign up for a Developer
              Account
              <br />
              <span className={styles.icon}>✦</span> Access your API keys and
              Sandbox environment
              <br />
              <span className={styles.icon}>✦</span> Follow our Quick Start
              Guide to begin integrating
              <br />
            </p>
            {/* <button className={styles.primaryButton}>
              Start Building <span className={styles.arrow}>→</span>
            </button> */}
          </div>
          <div
            className={styles.solutionImage}
            style={{ position: "relative", display: "inline-block" }}
          >
            <img
              src={check}
              alt="feature payment"
              style={{
                filter: "brightness(95%)",
                width: "650px",
                height: "250px",
                display: "block",
                borderRadius: "8px",
              }}
            />
          </div>
        </section>

        <section className={styles.apiDoc} style={{ marginLeft: "100px" }}>
          <p style={{marginBottom:'0'}} className={styles.sectionLabel}>API DOCUMENTATION</p>
          <h3 style={{ fontSize: "2.2em", marginBottom:"0", marginTop:"0" }}>Arifpay API Documentation</h3>
          <p className={styles.paragraph} style={{ colro: "black" }}>
            Explore our robust APIs for seamless payment processing
          </p>
          {/* <button
            className={styles.primaryButton}
            style={{ marginBottom: "50px" }}
          >
            View API Docs <span className={styles.arrow}>→</span>
          </button> */}
          {/* <div className={styles.solutionImage} style={{ width: "100%" }}>
            <img
              src={api}
              alt="feature payment"
              style={{
                filter: "brightness(95%)",
                Width: "70%",
                height: "auto",
                display: "block",
                borderRadius: "8px",
                marginBottom: "50px",
              }}
            />
          </div> */}

          <div
            ref={ApiPageRef}
            style={{
              display: "flex",
              gap: "20px",
              overflowX: "auto",
              paddingBottom: "20px",
              width: "100%",
              justifyContent:"center",
              // alignItems:"center",

              paddingRight: "20px",
              boxSizing: "border-box",
            }}
          >
            {displayedTestData.map((t, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#fff",
                  paddingTop: "30px",
                  marginTop: "10px",
                  borderRadius: "8px",
                  border: "1px solid lightgreen",
                  padding: "20px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  minWidth: "300px", // Adjust as needed
                }}
              >
                <img
                  src={t.img}
                  alt={t.name}
                  style={{
                    width: "50px",

                    height: "50px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                    objectFit: "cover",
                  }}
                />
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    lineHeight: "1.5",
                    marginBottom: "10px",
                  }}
                >
                  {t.text}
                </div>
              </div>
            ))}
          </div>
          {isSmallScreen && ApiItemsPerPage > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {Array.from({
                length: Math.ceil(test.length / ApiItemsPerPage),
              }).map((_, index) => (
                <button
                  key={index}
                  style={{
                    backgroundColor:
                      ApiCurrentPage === index + 1 ? "#8bc34a" : "#ddd",
                    border: "none",
                    borderRadius: "50%",
                    width: "10px",
                    height: "10px",
                    margin: "0 5px",
                    padding: 0,
                    cursor: "pointer",
                    fontSize: "0",
                  }}
                  onClick={() => handleApiPageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}
        </section>

        <section
          className={styles.dev}
          style={{
            marginTop: "80px",
            marginBottom: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap", // Optional: makes it responsive
            gap: "40px",
          }}
        >
          <div
            className={styles.viewText}
            style={{
              flex: "1",
              minWidth: "300px",
            }}
          >
            <p className={styles.sectionLabel}>SDK</p>
            <h2
              className={styles.tit}
              style={{
                fontSize: "28px",
                marginTop: 0,
                fontWeight: "bold",
                lineHeight: "1.2",
              }}
            >
              SDKs & Developer Tools
            </h2>
            <p style={{ fontSize: "1.3em" }} className={styles.paragraph}>
              Accelerate your integration with our SDKs and libraries
            </p>
            <p className={styles.parg} style={{ fontSize: "1.2em" }}>
              <span className={styles.icon}>✦</span> Python, JavaScript, Java,
              and more <br />
              <br />
              <span className={styles.icon}>✦</span> Open-source sample projects
              on GitHub
              <br />
              <br />
              <span className={styles.icon}>✦</span> Mobile SDKs for Android &
              IOS
            </p>
            {/* <button className={styles.primaryButton}>
              Start Building <span className={styles.arrow}>→</span>
            </button> */}
          </div>

          <div
            className={styles.solutionImage}
            style={{
              flex: "1",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "300px",
            }}
          >
            <img
              src={tool}
              alt="feature payment"
              style={{
                filter: "brightness(95%)",
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          </div>
        </section>

        <div
          className={styles.view}
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}
        >
          <div style={{ marginBottom: "30px", textAlign: "center" }}>
            {" "}
            {/* Added textAlign: 'center' here */}
            <h4
              style={{
                color: "#8bc34a",
                fontSize: "1.5em",
                marginBottom: "20px",
                fontWeight: "bold",
              }}
            >
              TEST & DEPLOY
            </h4>
            <h2
              style={{
                fontSize: "2em",
                overflow: "hidden",
                marginTop: 0,
                fontWeight: "bold",
                lineHeight: "1.2",
              }}
            >
              Test & Deploy with Confidence
            </h2>
            <p style={{ fontSize: "1.2em" }}>
              Connect with fellow developers, get support, and collaborate on
              open-source projects.
            </p>
          </div>

          <div
            ref={deployRef}
            style={{
              display: "flex",
              gap: "20px",
              overflowX: "auto",
              paddingBottom: "20px",
            }}
          >
            {displayedDeployData.map((t, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid lightgreen",
                  padding: "20px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  minWidth: "300px", // Adjust as needed
                }}
              >
                <img
                  src={t.img}
                  alt={t.name}
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                    objectFit: "cover",
                  }}
                />
                <p
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    lineHeight: "1.5",
                    marginBottom: "10px",
                  }}
                >
                  {t.text}
                </p>
              </div>
            ))}
          </div>
          {isSmallScreen && deployItemsPerPage > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {Array.from({
                length: Math.ceil(deployData.length / deployItemsPerPage),
              }).map((_, index) => (
                <button
                  key={index}
                  style={{
                    backgroundColor:
                      deployCurrentPage === index + 1 ? "#8bc34a" : "#ddd",
                    border: "none",
                    borderRadius: "50%",
                    width: "10px",
                    height: "10px",
                    margin: "0 5px",
                    padding: 0,
                    cursor: "pointer",
                    fontSize: "0",
                  }}
                  onClick={() => handleDeployPageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}

          <div
            className={styles.sandboxButton}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "30px",
            }}
          >
            {" "}
            {/* Added marginTop for spacing */}
            {/* <button
              style={{
                width: "260px",
                backgroundColor: "var(--primary-green)",
              }}
              className={styles.primaryButton}
            >
              Access Sandbox <span className={styles.arrow}>→</span>
            </button> */}
          </div>
        </div>

        <div
          className={styles.bottom}
          style={{
            backgroundColor: "black",
            color: "#fff",
            borderRadius: "35px",
            marginBottom: "10px",
            marginTop: "20px",
            paddingBottom: "0",
            paddingTop: "0",
            marginLeft: "50px",
            marginRight: "50px",
          }}
        >
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div
              className={styles.developerCommunity}
              style={{ flex: "1 1 300px", marginBottom: "8px" }}
            >
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "120px",
                }}
              >
                Join the Arifoch Developer Community
              </h2>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                  alignItems: "center",
                  marginLeft: "120px",
                }}
              >
                Connect with fellow developers, get support, and collaborate on
                open-source projects.
              </p>

              <div className={styles.heroButtons}>
                <button
                  onClick={handleTelegramLogin}
                  className={styles.primaryButton}
                >
                  Join our Telegram Group{" "}
                  <svg
                    className={styles.arrow}
                    width="10"
                    height="10"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.3787 17.0355C10.1392 16.9217 9.86081 16.9217 9.62134 17.0355L4.47635 19.4802C3.82468 19.7898 3.09663 19.2285 3.23581 18.5237L4.2851 13.2104C4.34063 12.9292 4.25392 12.6388 4.05306 12.4333L0.24956 8.54179C-0.25572 8.02483 0.0507134 7.15606 0.770008 7.06628L6.09202 6.40199C6.38352 6.36561 6.63742 6.1867 6.76858 5.92527L9.21406 1.0509C9.5375 0.406209 10.4625 0.40621 10.7859 1.0509L13.2314 5.92527C13.3626 6.1867 13.6165 6.36561 13.908 6.40199L19.23 7.06628C19.9493 7.15606 20.2557 8.02483 19.7504 8.54179L15.9469 12.4333C15.7461 12.6388 15.6594 12.9292 15.7149 13.2104L16.7642 18.5237C16.9034 19.2285 16.1753 19.7898 15.5237 19.4802L10.3787 17.0355Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {/* <button
                  style={{
                    height: "40px",
                    paddingTop: "10px",
                    borderRadius: "15px",
                  }}
                  className={styles.documentationButton}
                >
                  Contact our Developer Support
                </button> */}
              </div>
            </div>
          </div>
        </div>

        <section className={styles.devSection}>
          <p className={styles.subheading}>ARIF DEVELOPERS EVENT</p>
          <h2 className={styles.heading}>
            Have a look at our developer meetup
          </h2>

<div ref={eventsRef} className={styles.carousel}>
  {displayedEventsData.map((event, index) => (
    <div className={styles.card} key={index}>
      <div className={styles.media}>
        {event.type === "image" ? (
          <img
            src={event.src}
            alt={event.title}
            className={styles.image}
          />
        ) : (
<div className={styles.videoContainer}>
  <iframe
    className={styles.video}
    src={event.src}
    title={event.title}
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    frameBorder="0"
    allowFullScreen
  />
</div>

        )}
      </div>
      <p className={styles.date}>{event.date}</p>
      <h3 className={styles.title}>{event.title}</h3>
    </div>
  ))}
</div>
{eventsItemsPerPage > 0 && (
  <div className={styles.pagination}>
    {Array.from({
      length: Math.ceil(eventsData.length / eventsItemsPerPage),
    }).map((_, index) => (
      <button
        key={index}
        className={`${styles.paginationDot} ${
          eventsCurrentPage === index + 1 ? styles.activeDot : ''
        }`}
        onClick={() => handleEventsPageChange(index + 1)}
        type="button"  // Important: prevent form submission behavior
      >
        {index + 1}
      </button>
    ))}
  </div>
)}
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Developers;
